import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-form-footer',
  styleUrls: ['./form-footer.component.scss'],
  template: '<ng-content />'
})
export class FormFooterComponent {
}
